import React from 'react'
import { motion } from "framer-motion";

export default function BarLoader({ className }) {
  const variants = {
    initial: {
      scaleY: 0.5,
      opacity: 0,
    },
    animate: {
      scaleY: 1,
      opacity: 1,
      transition: {
        repeat: Infinity,
        repeatType: "mirror",
        duration: 1,
        ease: "circIn",
      },
    },
  };

  return (
    <motion.div
      transition={{
        staggerChildren: 0.25,
      }}
      initial="initial"
      animate="animate"
      className="flex gap-1"
    >
      <motion.div variants={variants} className={`${className} h-20 w-4 bg-black`} />
      <motion.div variants={variants} className={`${className} h-20 w-4 bg-black`} />
      <motion.div variants={variants} className={`${className} h-20 w-4 bg-black`} />
      <motion.div variants={variants} className={`${className} h-20 w-4 bg-black`} />
      <motion.div variants={variants} className={`${className} h-20 w-4 bg-black`} />
    </motion.div>
  )
}
